<div class="tw-flex tw-flex-col tw-h-full">
  <div class="tw-flex-auto tw-relative tw-h-full">
  @if (isTabActive.HOME) {
  <user-home id="tab1" [refresh]="isTabActive.HOME" [animation]="tabAnimation.HOME" [tabUpdates]="isTabHasUpdates" [showNotificationEnablePopUp]="showNotificationEnablePopUp"></user-home>
  }
  @if (isTabActive.CHAT) {
  <user-assistant id="tab2"></user-assistant>
  }
  @if (isTabActive.SHOP) {
  <user-shop id="tab5"></user-shop>
  }
  @if (isTabActive.REGIMEN) {
  <user-view-regimen id="tab3" [refresh]="isTabActive.REGIMEN" [animation]="tabAnimation.REGIMEN" (showNewRegimen)="setNewRegimenFlag($event)"></user-view-regimen>
  }
  @if (!exploreSectionExperiment && isTabActive.EXPLORE) {
  <user-explore id="tab4" [refresh]="isTabActive.EXPLORE" [animation]="tabAnimation.EXPLORE"></user-explore>
  }
  </div>
  @if (isBottomNavExperimentActive && !isTabActive.REGIMEN && !hideBottomNavBar) {
    <div class="tw-fixed tw-bottom-0 tw-left-0 tw-w-full tw-z-[1] tw-flex-none">
      <app-bottom-nav
        [user]="user"
        [isOnHoldPopupVisible]="isOnHoldPopupVisible" />
    </div>
  } @else {
    @if (!isTabActive.HOME && !isTabActive.REGIMEN && !hideBottomNavBar) {
    <div class="tw-fixed tw-bottom-0 tw-left-0 tw-w-full tw-z-[1] tw-flex-none tw tw-h-20 tw-flex tw-flex-row">
      <div class="tw-bg-white tw-border-t tw-border-gray-200 tw-flex tw-justify-around tw-w-full tw-overflow-hidden tw-h-20">
        <ng-container *ngTemplateOutlet="navBar"></ng-container>
      </div>
    </div>
    }
    @if (isTabActive.HOME && !hideBottomNavBar) {
    <div class="tw-fixed tw-bottom-0 tw-left-0 tw-w-full tw-z-[1] tw-flex-none tw tw-h-20 tw-flex tw-flex-row tw-border-none">
    <div class="tw-bg-white tw-border-t tw-border-gray-200 tw-flex tw-justify-around tw-w-full tw-overflow-hidden tw-h-20">
      <ng-container *ngTemplateOutlet="navBar"></ng-container>
    </div>
    </div>
    }
  }
  <!--    notification popup   -->
  @if (showNotificationEnablePopUp) {
  <notification-permission-popup
    (close)="respondPermissionPopup(false)"
    (enable)="respondPermissionPopup(true)">
  </notification-permission-popup>
  }
</div>
<!-- On hold popup -->
<app-on-hold-popup [ticketData]="onHoldTicket" [onHoldPopupResponse]="onHoldPopupResponse" [showOnHoldPopup]="showOnHoldPopup" [regimenClass]="onHoldRegimenClass" [showNotFeelingBetterPopup]="showNotFeelingBetterPopup" [showFeelingBetterPopup]="showFeelingBetterPopup" (onHoldResponsePositive)="onHoldResponse('BETTER')" (onHoldResponseNegative)="onHoldResponse('STILL_FACING_ISSUE')" [userResponse]="userResponse" (noOnHoldResponse)="onHoldResponse('NOT_RESPONDED')"  [holdData]="onHoldData" ></app-on-hold-popup>

<!-- Legacy nav bar template (experiment inactive) -->
<ng-template #navBar="">
  @if (!(showOnHoldPopup || showNotFeelingBetterPopup || showFeelingBetterPopup)) {
  <div class="tw-h-full tw-flex-1 tw-flex tw-flex-col tw-items-center tw-justify-between tw-pb-3" rippleEffect="rippleEffect" (callback)="onTabChange(0)">
  <div class="tw-flex-none tw-w-11 tw-h-1 tw-bg-black tw-rounded-br tw-rounded-bl" [ngClass]='{"tw-bg-teal-400": isTabActive.HOME, "tw-bg-white": !isTabActive.HOME}'></div>
  <div class="tw-flex-none tw-flex tw-flex-col tw-items-center tw-gap-0.5">
    @if (!isTabActive.HOME) {
    <cs-icon class="tw-h-7 tw-w-7 tw-text-gray-500" [iconName]='"https://cdn.cureskin.com/app/img/rebranded_home.svg"'></cs-icon>
    } @else {
    <cs-icon class="tw-h-7 tw-w-7" [iconName]='"https://cdn.cureskin.com/app/img/rebranded_home_solid.svg"'></cs-icon>
    }
    <div class="tw-font-body tw-text-200" i18n="@@home" [ngClass]="{ 'tw-text-gray-500': !isTabActive.HOME, 'tw-text-teal-400': isTabActive.HOME }">Home</div>
  </div>
  </div>
  } @else {
  <div class="tw-h-full tw-flex-1 tw-flex tw-flex-col tw-items-center tw-justify-between tw-pb-3" rippleEffect="rippleEffect" (callback)="onTabChange(0)">
    <div class="tw-flex-none tw-w-11 tw-h-1 tw-bg-black tw-rounded-br tw-bg-white tw-rounded-bl"></div>
    <div class="tw-flex-none tw-flex tw-flex-col tw-items-center tw-gap-0.5">
      <cs-icon class="tw-h-7 tw-w-7 tw-text-gray-500" [iconName]='"https://cdn.cureskin.com/app/img/rebranded_home.svg"'></cs-icon>
      <div class="tw-font-body tw-text-200 tw-text-gray-500" i18n="@@home">Home</div>
    </div>
  </div>
  }
  <div class="tw-flex-1 tw-flex tw-flex-col tw-items-center tw-justify-between tw-pb-3" rippleEffect="rippleEffect" (click)="needHelpClick()">
  <div class="tw-flex-none tw-w-11 tw-h-1 tw-rounded-br tw-rounded-bl" [ngClass]='{"tw-bg-teal-400": isTabActive.CHAT, "tw-bg-white": !isTabActive.CHAT}'></div>
  <div class="tw-flex-none tw-flex tw-flex-col tw-items-center tw-gap-0.5">
    @if (!isTabActive.CHAT) {
    <cs-icon class="tw-h-7 tw-w-7" [iconName]='"https://cdn.cureskin.com/app/img/rebranded_help.svg"'></cs-icon>
    } @else {
    <cs-icon class="tw-h-7 tw-w-7 tw-bg-teal-400" [iconName]='"https://cdn.cureskin.com/app/img/rebranded_help_solid.svg"'></cs-icon>
    }
    <div class="tw-font-body tw-text-200" i18n="@@help" [ngClass]="{ 'tw-text-gray-500': !isTabActive.CHAT, 'tw-text-teal-400': isTabActive.CHAT }">Help</div>
  </div>
  </div>
  @if (userStatus.PAID) {
  <div class="tw-flex-1 tw-flex tw-flex-col tw-items-center tw-justify-between tw-pb-3" rippleEffect="rippleEffect" (callback)="onTabChange(4);shopClick()">
  <div class="tw-flex-none tw-w-11 tw-h-1 tw-bg-white" [ngClass]='{"tw-bg-teal-400": isTabActive.SHOP, "tw-bg-white": !isTabActive.SHOP}'></div>
  <div class="tw-flex-none tw-flex tw-flex-col tw-items-center tw-gap-0.5">
    @if (!isTabActive.SHOP) {
    <cs-icon class="tw-h-7 tw-w-7" [iconName]='"https://cdn.cureskin.com/app/img/rebranded_storefront.svg"'></cs-icon>
    } @else {
    <cs-icon class="tw-h-7 tw-w-7" [iconName]='"https://cdn.cureskin.com/app/img/rebranded_storefront_solid.svg"'></cs-icon>
    }
    <div class="tw-font-body tw-text-200" i18n="@@shop" [ngClass]="{ 'tw-text-gray-500': !isTabActive.SHOP, 'tw-text-teal-400': isTabActive.SHOP }">Shop</div>
  </div>
  </div>
  } @else {
  <div class="tw-flex-1 tw-flex tw-flex-col tw-items-center tw-justify-between tw-pb-3" rippleEffect="rippleEffect" (callback)="cameraClick()">
  <div class="tw-flex-none tw-w-11 tw-h-1 tw-bg-white"></div>
  <div class="tw-flex-none tw-flex tw-flex-col tw-items-center tw-gap-0.5">
    <cs-icon class="tw-h-7 tw-w-7" [iconName]='"https://cdn.cureskin.com/app/img/rebranded_photo_camera.svg"'></cs-icon>
    <div class="tw-font-body tw-text-200 tw-text-gray-500" i18n="@@photo">Photo</div>
  </div>
  </div>
  }
  <div class="tw-flex-1 tw-flex tw-flex-col tw-items-center tw-justify-between tw-pb-3" rippleEffect="rippleEffect" (callback)="onTabChange(2)">
  <div class="tw-flex-none tw-w-11 tw-h-1 tw-bg-black tw-rounded-br tw-rounded-bl" [ngClass]='{"tw-bg-teal-400": isTabActive.REGIMEN, "tw-bg-white": !isTabActive.REGIMEN}'></div>
  <div class="tw-flex-none tw-flex tw-flex-col tw-items-center tw-gap-0.5">
    <cs-icon class="tw-h-7 tw-w-7" [iconName]='"https://cdn.cureskin.com/app/img/rebranded_sanitizer.svg"' [ngClass]="{ 'tw-text-gray-500': !isTabActive.REGIMEN, 'tw-text-black': isTabActive.REGIMEN }"></cs-icon>
    <div class="tw-font-body tw-text-200" i18n="@@treatment" [ngClass]="{ 'tw-text-gray-500': !isTabActive.REGIMEN, 'tw-text-black': isTabActive.REGIMEN }">
    Treatment
    </div>
  </div>
  </div>
  @if (showShowExploreTab) {
  <div class="tw-flex-1 tw-flex tw-flex-col tw-items-center tw-justify-between tw-pb-3" rippleEffect="rippleEffect" (callback)="onTabChange(3);exploreClick()">
  <div class="tw-flex-none tw-w-11 tw-h-1 tw-bg-black tw-rounded-br tw-rounded-bl" [ngClass]='{"tw-bg-teal-400": isTabActive.EXPLORE, "tw-bg-white": !isTabActive.EXPLORE}'></div>
  <div class="tw-flex-none tw-flex tw-flex-col tw-items-center tw-gap-0.5">
    @if (!isTabActive.EXPLORE) {
    <cs-icon class="tw-h-7 tw-w-7 tw-text-gray-500" [iconName]='"https://cdn.cureskin.com/app/img/rebranded_manage_search.svg"'></cs-icon>
    } @else {
    <cs-icon class="tw-h-7 tw-w-7" [iconName]='"https://cdn.cureskin.com/app/img/rebranded_manage_search_solid.svg"'></cs-icon>
    }
    <div class="tw-font-body tw-text-200" i18n="@@explore" [ngClass]="{ 'tw-text-gray-500': !isTabActive.EXPLORE, 'tw-text-teal-400': isTabActive.EXPLORE }">Explore</div>
  </div>
  </div>
  }
</ng-template>
